angular.module('content.widgets.LOWidgetController', [
  'content.widgets.LOWidgetService'
])

/**
 * The LOWidgetController manages scope logic and user
 * interaction.
 *
 * @class LOWidgetController
 * @constructor
 * @module content.widgets.LOWidgetController
 **/
.controller('LOWidgetController', [
  '$scope',
  '$state',
  'LOWidgetService',
  'StatesService',
  'SimulationService',
  'EventsWidgetService',
  function (
    $scope,
    $state,
    LOWidgetService,
    StatesService,
    SimulationService,
    EventsWidgetService
  ) {
    'use strict';

    $scope.formattedModel = {};

    $scope.state = {
      selected: null,
      breadcrumbs: [],
      list: [],
      media: []
    };

    $scope.submit = function (button) {
      $scope.processing = true;

      return EventsWidgetService
        .process($state.params.stateId, 'lo', button.id)
        .then(function (response) {
          SimulationService.addToDisabled($state.params.stateId);
          StatesService.goToState(response.content.feedback.targetId);
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };


    /**
     * Returns the model captured from edit mode
     *
     * @return {Object} Widget instance model
     */
    $scope.getModel = function getModel() {
      return LOWidgetService.getModel($scope.model, $scope.form.model);
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);

      $scope.formattedModel = {
        title: $scope.model.label,
        los: $scope.model.content.decisions.content.stem,
        choices: $scope.model.content.decisions.content.choices,
        media: $scope.model.content.media
      };

      if ($scope.formattedModel.los) {
        $scope.formattedModel.los = JSON.parse($scope.formattedModel.los);
      } else {
        $scope.formattedModel.los = '[]';
      }

      console.log($scope.formattedModel);

      if (!_.isArray($scope.model.content.rules)) {
        $scope.form = LOWidgetService.configureForm($scope.model);
      }
    }

    initialize();
  }
]);
